import { render, staticRenderFns } from "./GettingStartedFormAlt.vue?vue&type=template&id=2c1a1d7c&scoped=true"
import script from "./GettingStartedFormAlt.vue?vue&type=script&lang=js"
export * from "./GettingStartedFormAlt.vue?vue&type=script&lang=js"
import style0 from "./GettingStartedFormAlt.vue?vue&type=style&index=0&id=2c1a1d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a1d7c",
  null
  
)

export default component.exports